import { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Checkbox } from "./ui/checkbox";
import { Loader2, BookText, Plus, Trash2, Save, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

// Impostazioni → Frasario Diario: frasi predefinite per le note, con flag "Visibile al cliente".
export default function FrasarioDiarioSettings() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/studio/frasario-diario").then(({ data }) => setItems(data || [])).catch(() => {}).finally(() => setLoading(false)); }, []);

  const upd = (i, patch) => setItems((l) => l.map((x, j) => (j === i ? { ...x, ...patch } : x)));
  const save = async () => {
    setSaving(true);
    try { const { data } = await api.put("/studio/frasario-diario", { items }); setItems(data); toast.success("Frasario salvato"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div id="sez-frasario" className="pgp-card p-6 max-w-2xl mt-6 pgp-fade-up" data-testid="frasario-config">
      <h3 className="font-head font-semibold text-slate-100 flex items-center gap-2"><BookText className="h-4 w-4 text-amber-400" /> Frasario Diario</h3>
      <p className="text-sm text-slate-400 mt-1">Frasi predefinite da inserire rapidamente come note nel Diario della pratica. La spunta decide se la nota sarà visibile nell'area riservata del cliente.</p>
      {loading ? <div className="py-6 flex justify-center"><Loader2 className="h-5 w-5 animate-spin text-amber-500" /></div> : (
        <div className="mt-4 space-y-2" data-testid="frasario-list">
          {items.length === 0 && <div className="text-sm text-slate-500">Nessuna frase. Aggiungine una.</div>}
          {items.map((it, i) => (
            <div key={i} className="flex items-center gap-2" data-testid={`frasario-row-${i}`}>
              <Input value={it.testo} onChange={(e) => upd(i, { testo: e.target.value })} placeholder="Testo della frase" data-testid={`frasario-testo-${i}`} className="bg-slate-900/60 border-slate-700" />
              <label className="flex items-center gap-1.5 text-xs text-slate-300 whitespace-nowrap cursor-pointer" title="Visibile al cliente">
                <Checkbox checked={!!it.visibile_cliente} onCheckedChange={(v) => upd(i, { visibile_cliente: !!v })} data-testid={`frasario-vis-${i}`} />
                {it.visibile_cliente ? <Eye className="h-3.5 w-3.5 text-emerald-400" /> : <EyeOff className="h-3.5 w-3.5 text-red-500" />} Visibile al cliente
              </label>
              <button type="button" onClick={() => setItems((l) => l.filter((_, j) => j !== i))} title="Elimina frase" data-testid={`frasario-del-${i}`} className="text-red-400 hover:text-red-300 p-1"><Trash2 className="h-4 w-4" /></button>
            </div>
          ))}
          <div className="flex gap-2 pt-2">
            <Button type="button" variant="outline" onClick={() => setItems((l) => [...l, { testo: "", visibile_cliente: false }])} data-testid="frasario-add" className="h-9 border-slate-700"><Plus className="h-4 w-4 mr-1" /> Aggiungi frase</Button>
            <Button type="button" onClick={save} disabled={saving} data-testid="frasario-save" className="h-9 bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">
              {saving ? <Loader2 className="h-4 w-4 animate-spin mr-1" /> : <Save className="h-4 w-4 mr-1" />} Salva frasario
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
